import React, { useEffect, useState } from 'react'
import { Container, Box, Alert } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { RegisterForm } from '../components/auth/RegisterForm'
import { LoginForm } from '../components/auth/LoginForm'
import { useAuth } from '../contexts/AuthContext'

export const RegisterPage: React.FC = () => {
  const navigate = useNavigate()
  const { user, isAuthenticated } = useAuth()
  const [showLogin, setShowLogin] = useState(false)
  const [successMessage, setSuccessMessage] = useState<string>('')

  // 既に認証済みの場合は自動でダッシュボードにリダイレクト
  useEffect(() => {
    if (isAuthenticated && user) {
      navigate('/dashboard', { replace: true })
    }
  }, [isAuthenticated, user, navigate])

  const handleRegistrationSuccess = () => {
    setSuccessMessage(
      '企業登録が完了しました！ログイン用のリンクをメールで送信いたしました。メールをご確認ください。'
    )

    // 成功メッセージを3秒表示後、ログイン画面へリダイレクト
    setTimeout(() => {
      navigate('/login', { replace: true })
    }, 3000)
  }

  const handleSwitchToLogin = () => {
    setShowLogin(true)
    setSuccessMessage('')
  }

  const handleSwitchToRegister = () => {
    setShowLogin(false)
    setSuccessMessage('')
  }

  const handleLoginSuccess = () => {
    navigate('/dashboard', { replace: true })
  }

  if (isAuthenticated && user) {
    return null // リダイレクト処理中
  }

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          py: 4,
        }}
      >
        {successMessage && (
          <Alert severity="success" sx={{ mb: 3, maxWidth: 500, mx: 'auto' }}>
            {successMessage}
          </Alert>
        )}

        {showLogin ? (
          <LoginForm onSuccess={handleLoginSuccess} onSwitchToRegister={handleSwitchToRegister} />
        ) : (
          <RegisterForm
            onSuccess={handleRegistrationSuccess}
            onSwitchToLogin={handleSwitchToLogin}
          />
        )}
      </Box>
    </Container>
  )
}
